import React from 'react'
import { Tag } from 'src/common/razzle-platform-components/types'
import classNames from 'classnames'
import { Button ,Typography} from '@material-ui/core'
import { useTagsOfProducts } from 'src/common/razzle-platform-product/hooks'

const TAGS_FILTER_NAME = 'tags.id'

export const TagsFilterButton = (props) => {
    const { setFilter, filters, classes } = props
    const { tagsOfProducts } = useTagsOfProducts()
    const handleTagFilterClick = (tag: Tag) => {
        const currentFilterValue = Array.from(filters[TAGS_FILTER_NAME] ?? [])
        const isFilterActive = currentFilterValue.includes(tag.id)
        setFilter(
            {
                [TAGS_FILTER_NAME]: isFilterActive
                    ? currentFilterValue.filter((id) => id !== tag.id)
                    : [...currentFilterValue, tag.id],
            },
            true,
            true,
        )
    }
    return (
        <>
            {tagsOfProducts
                ?.filter((tag) => tag.statusOnFilter === 'main')
                .map((tag) => {
                    return (
                        <div className="mr-2">
                            <Button
                                id="tagsFilter"
                                name={TAGS_FILTER_NAME}
                                onClick={() => handleTagFilterClick(tag)}
                                variant="outlined"
                                size="medium"
                                className={classNames(
                                    filters[TAGS_FILTER_NAME] && filters[TAGS_FILTER_NAME].length === 1
                                        ? classes.filterButtonActive
                                        : '',
                                    classes.filterButton,
                                )}
                            >
                                <Typography>{tag.name}</Typography>
                            </Button>
                        </div>
                    )
                })}
        </>
    )
}
